import { EmailTemplateConfig } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';

export class EmailTemplateHttpService extends CRUDHelperBase<EmailTemplateConfig> {
	constructor() {
		super(EmailTemplateConfig.name);
	}
}
